import React, { useEffect } from 'react';
const DocumentTitle = ({ title, children }) => {
    useEffect(() => {
        document.title = title ? `${title} | Login | Ally` : 'Login | Ally';
        return () => {
            document.title = 'Ally';
        };
    }, [title]);
    return React.createElement(React.Fragment, null, children);
};
export { DocumentTitle };
//# sourceMappingURL=DocumentTitle.js.map